import filter from '../../api/index'

const GetByReportTypeId = (query) => {
    return new Promise((resolve) => {
        resolve(filter.filter.getByReportTypeId(query))
    })
}

export default{
    namespaced: true,
    state: {
        reportTypeFilters: [],
    },
    getters: {
        GET_REPORT_TYPE_FILTERS(state){
          return state.reportTypeFilters;
        }
    },
    mutations: {
        SET_REPORT_TYPE_FILTERS(state, payload){
            state.reportTypeFilters = payload;
        },
    },
    actions: {
        async GET_BY_REPORT_TYPE_ID({commit}, payload){
            await GetByReportTypeId(payload).then(
              ({
                data, status
              }) => {
                if(status === 200){
                    commit('SET_REPORT_TYPE_FILTERS', data);
                }                    
              }
            )       
        },
    }
}